import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingAnimation from "../../Components/Loading/LoadingAnimation";
import {
  createProject,
  updateProject,
  getProjectTypeById,
  createPorjectComment,
  getPorjectComment,
  deletePorjectComment,
} from "../../Constants/apiRoutes";
import {
  GET_ALL_DOCUMENT_API,
} from "../../Constants/apiRoutes";
import { useParams } from "react-router-dom";
import {
  FaEdit,
  FaDownload,
  FaTrash,
  FaEye,
  FaFile,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
} from "react-icons/fa";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/20/solid";
import { FaPlus } from "react-icons/fa";
import { TrashIcon } from "@heroicons/react/24/solid";
import { BsArrowUpRightCircleFill } from "react-icons/bs";
import { useConfirmation } from "../../Components/ConfirmDialog";
import { GrInProgress } from "react-icons/gr";

const ProjectStatus = [
  { id: 1, name: "Project Initation" },
  { id: 2, name: "Project Planning" },
  { id: 3, name: "Project Execution" },
  { id: 4, name: "Project Control" },
  { id: 5, name: "Project Close" },
];

const AddProject = () => {
  const [formData, setFormData] = useState({
    storeId: "",
    projectName: "",
    isActive: false,
    imageFile: null,
    imagePreview: null,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const { ProjectTypeID } = useParams();
  const [projectType, setProjectType] = useState("");
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyTexts, setReplyTexts] = useState("");
  const [documentComments, setDocumentComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [isSubmittingComment, setIsSubmittingComment] = useState(false);
  const { showConfirmation, ConfirmationDialog } = useConfirmation();

  const handleCancel = () => {
    navigate("/Project"); // Navigate to the project list page
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors({ ...errors, [name]: "" });
  };
  const validateForm = () => {
    const formErrors = {};

    if (!formData.projectName.trim()) {
      formErrors.projectName = "Project Name is required.";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors = valid
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (ProjectTypeID) {
      axios
        .get(`${getProjectTypeById}/${ProjectTypeID}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // Validate that the response structure matches the expected format
          if (
            response.data &&
            response.data.message === "Project Type retrieved successfully"
          ) {
            setProjectType(response.data.data); // Update state with project type data
          } else {
            console.error("Unexpected response structure:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching project type data:", error);
        });
    }
  }, [ProjectTypeID]);

  useEffect(() => {
    if (editMode && projectType) {
      // Find the matching status object from ProjectStatus list
      const matchedStatus = ProjectStatus.find(
        (status) => status.id === projectType.ProjectPhaseID
      );

      setFormData({
        projectName: projectType.ProjectTypeName?.replace(/['"]/g, "") || "",
        isActive: projectType.Status,
        imageFile: projectType.FileUrl || null,
        imagePreview: projectType.FileUrl || null,
        ProjectPhaseID: projectType.ProjectPhaseID || "", // Set ID
      });

      setSelectedProjectStatus(matchedStatus || null); // Set selected status object for Combobox
    }
  }, [editMode, projectType, ProjectStatus]);

  const handleSubmit = async () => {
    if (validateForm()) {
      setLoading(true);

      const projectData = {
        ProjectTypeName: String(formData.projectName),
        Status: formData.isActive ? "Active" : "Inactive",
        CreatedBy: "admin",
        ProjectPhaseID: formData.ProjectPhaseID,
      };

      const token = localStorage.getItem("token");

      try {
        const response = await axios.post(createProject, projectData, {
          headers: {
            "Content-Type": "application/json", // Changed to JSON
            Authorization: `Bearer ${token}`,
          },
        });

        // Show success toast notification
        toast.success(response.data.message || "Project added successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        // Reset form fields
        setFormData({
          storeId: "", // Clear storeId
          projectName: "", // Clear projectName
          isActive: false, // Reset isActive to false
          imageFile: null, // Clear imageFile
          imagePreview: null, // Clear imagePreview
        });

        // Clear file input field
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }

        setTimeout(() => {
          handleCancel(); // Call the handleCancel function after the delay
        }, 3000);
      } catch (error) {
        // Show error toast notification
        toast.error(error.response?.data?.message || "Failed to add project!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      setLoading(false);
    }
  };

  useEffect(() => {
    if (ProjectTypeID) {
      setEditMode(Boolean(ProjectTypeID)); // Set editMode based on categoryData
    }
  }, [ProjectTypeID]);
  const handleProjectUpdate = async () => {
    setLoading(true);

    const projectData = {
      ProjectTypeName: formData.projectName,
      Status: formData.isActive, // Match backend expectations
      UploadDocument: formData.imageFile, // Ensure backend accepts this as a normal file path or URL
      ProjectPhaseID: formData.ProjectPhaseID,
      CreatedBy: "admin",
      UpdatedBy: "admin",
    };

    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${updateProject}/${ProjectTypeID}`, // Include project ID in the URL
        projectData,
        {
          headers: {
            "Content-Type": "application/json", // Changed to JSON
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Show success toast notification
      toast.success(response.data.message || "Project updated successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Reset form fields
      setFormData({
        storeId: "", // Clear storeId
        projectName: "", // Clear projectName
        isActive: false, // Reset isActive to false
        imageFile: null, // Clear imageFile
        imagePreview: null, // Clear imagePreview
        projectId: "", // Clear projectId for subsequent submissions
      });

      // Clear file input field
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      setTimeout(() => {
        handleCancel(); // Call the handleCancel function after the delay
      }, 1000);
    } catch (error) {
      // Show error toast notification
      toast.error(
        error.response?.data?.message || "Failed to update project!",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    }

    setLoading(false);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [itemsPerPage] = useState(6);
  const [documents, setDocuments] = useState([]);
  const [selectedProjectStatus, setSelectedProjectStatus] = useState(null);
  const [activeStep, setActiveStep] = useState(0);

  const fetchDocuments = async (projectPhaseId = null) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("UserID");

    try {
      const response = await axios.get(GET_ALL_DOCUMENT_API, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...(ProjectTypeID && { ProjectTypeId: ProjectTypeID }),
          ...(projectPhaseId && { ProjectPhaseId: projectPhaseId }),
          UserId: userId,
        },
      });

      if (response.data?.data) {
        setDocuments(response.data.data);
      } else {
        console.warn("No documents found");
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!ProjectTypeID) return;

    fetchDocuments();
  }, [ProjectTypeID, selectedProjectStatus]);
  const fetchComments = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${getPorjectComment}/${ProjectTypeID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setDocumentData(response.data.data); // assuming response.data is the shape you're expecting
      console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {
    if (ProjectTypeID) {
      fetchComments();
    }
  }, [ProjectTypeID]);

  // Calculate pagination values
  const filteredDocuments = documents.filter((doc) => {
    if (!selectedStatus || selectedStatus === "All") return true;
    return doc.StatusId === selectedStatus;
  });

  const totalItems = filteredDocuments.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = filteredDocuments.slice(startIndex, endIndex);


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxVisibleButtons = 5;
    let startPage = Math.max(
      1,
      currentPage - Math.floor(maxVisibleButtons / 2)
    );
    let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);

    if (endPage - startPage + 1 < maxVisibleButtons) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }

    // Add first page button
    if (startPage > 1) {
      buttons.push(
        <button
          key="1"
          onClick={() => handlePageChange(1)}
          className="relative inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
        >
          1
        </button>
      );
      if (startPage > 2) {
        buttons.push(
          <span
            key="ellipsis1"
            className="relative inline-flex items-center px-3 py-2 text-sm text-gray-700"
          >
            ...
          </span>
        );
      }
    }

    // Add page buttons
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`relative inline-flex items-center px-3 py-2 text-sm font-medium ${
            currentPage === i
              ? "z-10 bg-gradient-to-br from-[#8B4513] via-[#A0522D] to-[#D2691E] text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B4513]"
              : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
          }`}
        >
          {i}
        </button>
      );
    }

    // Add last page button
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons.push(
          <span
            key="ellipsis2"
            className="relative inline-flex items-center px-3 py-2 text-sm text-gray-700"
          >
            ...
          </span>
        );
      }
      buttons.push(
        <button
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
          className="relative inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
        >
          {totalPages}
        </button>
      );
    }

    return buttons;
  };
  const handleNavigation = (documentId) => {
    navigate(`/documentsDetails/${documentId}`);
  };

  const handleEdit = (documentId) => {
    navigate(`/add-document/${documentId}`);
  };

  const handleAddComment = () => {
    setShowCommentModal(true);
  };
  const handleDeleteComment = (commentId) => {
    showConfirmation(
      "Delete Comment",
      "Are you sure you want to delete this comment?",
      async () => {
        try {
          console.log("Trying to delete comment ID:", commentId);
          const token = localStorage.getItem("token");
          const res = await fetch(`${deletePorjectComment}/${commentId}`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

          const result = await res.json();
          console.log("Delete API response:", result);

          if (!res.ok) {
            throw new Error(result.message || "Failed to delete comment");
          }

          setDocumentComments((prev) =>
            prev.filter((c) => c.CommentID !== commentId)
          );
          fetchComments();
        } catch (error) {
          console.error("Delete error:", error);
          throw error; // This will trigger the error toast
        }
      }
    );
  };

  const handleDeleteReply = (replyId) => {
    showConfirmation(
      "Delete Reply",
      "Are you sure you want to delete this reply?",
      async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(`${deletePorjectComment}/${replyId}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          if (!res.ok) {
            throw new Error("Failed to delete reply");
          }

          setDocumentData((prevData) => ({
            ...prevData,
            Comments: Array.isArray(prevData.Comments)
              ? prevData.Comments.filter(
                  (comment) => comment.CommentID !== replyId
                )
              : [],
          }));
          fetchComments();
        } catch (error) {
          console.error(error);
          throw error; // This will trigger the error toast
        }
      }
    );
  };

  const handleReplySubmit = async (commentID) => {
    const reply = replyTexts[commentID];
    if (!reply?.trim()) {
      toast.error("Please enter a reply");
      return;
    }

    const token = localStorage.getItem("token");
    const userId = Number(localStorage.getItem("UserID"));
    const tenantId = Number(localStorage.getItem("TenantID"));
    const projectTypeId = Number(ProjectTypeID); // make sure it's a number

    try {
      const response = await axios.post(
        createPorjectComment,
        {
          ProjectTypeID: projectTypeId,
          UserID: userId,
          CommentText: reply,
          TenantId: tenantId,
          ParentCommentID: commentID,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Reply added successfully");
        setReplyTexts((prev) => ({ ...prev, [commentID]: "" }));
        setReplyingTo(null);

        fetchComments();
      } else {
        toast.error(response.data.message || "Failed to add reply");
      }
    } catch (error) {
      console.error("Failed to add sub-comment", error);
      toast.error("Failed to add reply");
    }
  };

  const handleSubmitComment = async () => {
    if (!commentText.trim()) {
      toast.error("Please enter a comment");
      return;
    }

    setIsSubmittingComment(true);
    const token = localStorage.getItem("token");
    const userId = Number(localStorage.getItem("UserID"));
    const tenantId = Number(localStorage.getItem("TenantID"));
    const projectTypeId = Number(ProjectTypeID); // make sure it's a number

    try {
      const response = await axios.post(
        createPorjectComment,
        {
          UserID: userId,
          CommentText: commentText,
          TenantId: tenantId,
          ParentCommentID: 0,
          ProjectTypeID: projectTypeId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Comment added successfully");
        setCommentText("");
        setShowCommentModal(false);

        fetchComments();
      } else {
        toast.error(response.data.message || "Failed to add comment");
      }
    } catch (error) {
      console.error("Error adding comment:", error);
      toast.error("Failed to add comment");
    } finally {
      setIsSubmittingComment(false);
    }
  };

  const handleStepClick = (index, projectPhaseId) => {
    setActiveStep(index);
    fetchDocuments(projectPhaseId); // Pass the selected phase to API
  };
  return (
    <div className="main-container">
      <div className="mt-6 p-6">
        <ToastContainer />
        <ConfirmationDialog />
        <h2 className="heading">
          {editMode ? "Update Project" : "Add Project"}
        </h2>
        <hr className="border-gray-300 my-4 mb-4" />

        <div className="flex flex-col lg:flex-row gap-6 p-4">
          <div className="w-full lg:w-2/3">
            {/* Project Name */}
            <div className="mt-8 mb-4 flex items-center">
              <label className="block font-semibold w-1/3 text-right pr-4 mb-6">
                Project Name <span className="text-red-500">*</span>:
              </label>
              <div className="w-2/3">
                <input
                  type="text"
                  name="projectName"
                  value={formData.projectName}
                  onChange={handleInputChange}
                  className={`border p-2 w-full sm:w-2/3 rounded-md ${
                    errors.projectName ? "border-red-500" : "border-gray-300"
                  }`}
                  placeholder="Enter Project Name"
                />

                <p
                  className={`text-red-500 text-sm h-5 ${
                    errors.projectName ? "visible" : "invisible"
                  }`}
                >
                  {errors.projectName}
                </p>
              </div>
            </div>

            {/* Stepper */}
            <div className="flex overflow-x-auto space-x-8 px-20 pb-4 mt-4">
              {ProjectStatus.map((status, index) => {
                const isCompleted = index < activeStep;
                const isActive = index === activeStep;
                const showLine = index < ProjectStatus.length - 1;

                return (
                  <div
                    key={status.id}
                    className="flex flex-col items-center relative min-w-max cursor-pointer"
                    onClick={() => handleStepClick(index, status.id)}
                  >
                    {/* Step Circle */}
                    <div
                      className={`w-8 h-8 flex items-center justify-center rounded-full text-white font-bold z-10
                  ${
                    isCompleted
                      ? "bg-green-500"
                      : isActive
                      ? "bg-orange-500"
                      : "bg-gray-300"
                  }
                `}
                    >
                      {isCompleted ? (
                        "✓"
                      ) : isActive ? (
                        <GrInProgress className="text-white" />
                      ) : (
                        <span className="text-black text-sm">✓</span>
                      )}
                    </div>

                    {/* Label below */}
                    <span className="mt-2 text-xs text-center max-w-[6rem]">
                      {status.name}
                    </span>

                    {/* Connector Line */}
                    {showLine && (
                      <div className="absolute top-4 left-1/2 w-28 h-0.5 bg-gray-300 z-0 -translate-x-0">
                        {isCompleted && (
                          <div className="w-full h-full bg-green-500" />
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Is Active */}
            <div className="mb-4 flex items-center">
              <label className="block font-semibold w-1/3 text-right pr-4">
                Is Active:
              </label>
              <div className="w-2/3">
                <div
                  onClick={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      isActive:
                        prevData.isActive === "Active" ? "Inactive" : "Active",
                    }))
                  }
                  className={`relative w-14 h-6 rounded-full cursor-pointer transition ${
                    formData.isActive === "Active"
                      ? "bg-green-500"
                      : "bg-red-500"
                  }`}
                >
                  <div
                    className={`absolute top-1/2 left-1 transform -translate-y-1/2 w-5 h-5 bg-white rounded-full shadow-md transition-transform ${
                      formData.isActive === "Active"
                        ? "translate-x-8"
                        : "translate-x-0"
                    }`}
                  ></div>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-6 flex ml-64 justify-center space-x-4">
              <button
                type="button"
                className="button-base save-btn"
                onClick={editMode ? handleProjectUpdate : handleSubmit}
              >
                {editMode ? "Update" : "Save"}
              </button>

              <button
                type="button"
                onClick={handleCancel}
                className="button-base save-btn"
              >
                Cancel
              </button>
            </div>
          </div>
          {ProjectTypeID && (
            <div className="w-full lg:w-1/3">
              <div className="flex items-center justify-between mt-6 mb-4">
                <h2 className="text-xl font-semibold text-gray-800">
                  Comments
                </h2>
                <button
                  onClick={handleAddComment}
                  className="px-4 py-2 bg-[#8B4513] text-white rounded hover:bg-opacity-90 flex items-center"
                >
                  <FaPlus className="w-4 h-4" />
                </button>
              </div>

              <div className="max-h-[300px] overflow-y-auto pr-2 space-y-5">
                {documentData?.length > 0 ? (
                  documentData
                    .filter((comment) => comment.ParentCommentID === null)
                    .map((parentComment) => {
                      const replies = documentData.filter(
                        (reply) =>
                          reply.ParentCommentID === parentComment.CommentID
                      );

                      return (
                        <div
                          key={parentComment.CommentID}
                          className="bg-white p-4 rounded-lg shadow-sm border"
                        >
                          {/* Parent comment */}
                          <div className="flex justify-between items-start mb-1">
                            <div>
                              <p className="text-base font-medium text-gray-800">
                                {parentComment.UserName || "Unknown User"}
                              </p>
                              <p className="text-xs text-gray-500">
                                {new Date(
                                  parentComment.CreatedDate
                                ).toLocaleString()}
                              </p>
                            </div>
                            <div className="flex items-center space-x-3">
                              <button
                                onClick={() =>
                                  setReplyingTo(
                                    replyingTo === parentComment.CommentID
                                      ? null
                                      : parentComment.CommentID
                                  )
                                }
                                className="text-blue-600 text-sm hover:underline"
                              >
                                Reply
                              </button>
                              <button
                                onClick={() =>
                                  handleDeleteComment(parentComment.CommentID)
                                }
                                className="text-[#8B4513] hover:text-red-500"
                              >
                                <TrashIcon className="w-4 h-4" />
                              </button>
                            </div>
                          </div>

                          <p className="text-sm text-gray-700 mt-2">
                            {parentComment.CommentText}
                          </p>

                          {/* Reply input */}
                          {replyingTo === parentComment.CommentID && (
                            <div className="mt-3 relative max-w-md">
                              <input
                                type="text"
                                value={
                                  replyTexts[parentComment.CommentID] || ""
                                }
                                onChange={(e) =>
                                  setReplyTexts({
                                    ...replyTexts,
                                    [parentComment.CommentID]: e.target.value,
                                  })
                                }
                                placeholder="Write a reply..."
                                className="w-full pr-10 px-3 py-2 border rounded text-sm"
                              />
                              <button
                                onClick={() =>
                                  handleReplySubmit(parentComment.CommentID)
                                }
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-[#8B4513] hover:text-[#A0522D]"
                              >
                                <BsArrowUpRightCircleFill size={20} />
                              </button>
                            </div>
                          )}

                          {/* Replies */}
                          {replies.length > 0 && (
                            <div className="mt-4 space-y-3 pl-4 border-l-2 border-gray-200">
                              {replies.map((reply) => (
                                <div
                                  key={reply.CommentID}
                                  className="bg-gray-100 p-3 rounded-lg shadow-sm"
                                >
                                  <div className="flex justify-between items-start mb-1">
                                    <div>
                                      <p className="text-sm font-medium text-gray-700">
                                        {reply.UserName || "Unknown User"}
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        {new Date(
                                          reply.CreatedDate
                                        ).toLocaleString()}
                                      </p>
                                    </div>
                                    <button
                                      onClick={() =>
                                        handleDeleteReply(reply.CommentID)
                                      }
                                      className="text-[#8B4513] hover:text-red-500"
                                    >
                                      <TrashIcon className="w-3.5 h-3.5" />
                                    </button>
                                  </div>
                                  <p className="text-sm text-gray-600 mt-1">
                                    {reply.CommentText}
                                  </p>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })
                ) : (
                  <p className="text-sm text-gray-600">
                    No comments available.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Comment Modal */}
      {showCommentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[600px] max-w-[90%]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Add Comment</h2>
              <button
                onClick={() => setShowCommentModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <span className="sr-only">Close</span>
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <textarea
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              className="w-full h-32 p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your comment here..."
            />
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowCommentModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitComment}
                disabled={isSubmittingComment}
                className={`px-4 py-2 bg-[#8B4513] text-white rounded hover:bg-[#8B4513] flex items-center ${
                  isSubmittingComment ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {isSubmittingComment ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Submitting...
                  </>
                ) : (
                  "Submit Comment"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Documents Grid */}
      {ProjectTypeID && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-6">
            {currentItems.map((doc) => (
              <div
                key={doc.DocumentID}
                className="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300"
              >
                <div className="p-4 sm:p-6">
                  <div
                    className="flex flex-col sm:flex-row sm:items-start justify-between gap-2 sm:gap-0 mb-4"
                    onClick={() => handleNavigation(doc.DocumentID)}
                  >
                    <div className="flex items-start space-x-3 cursor-pointer">
                      {doc.FilePath ? (
                        doc.FilePath.toLowerCase().endsWith(".pdf") ? (
                          <FaFilePdf className="w-5 h-5 text-red-500" />
                        ) : doc.FilePath.toLowerCase().endsWith(".docx") ||
                          doc.FilePath.toLowerCase().endsWith(".doc") ? (
                          <FaFileWord className="w-5 h-5 text-blue-600" />
                        ) : doc.FilePath.toLowerCase().endsWith(".xlsx") ||
                          doc.FilePath.toLowerCase().endsWith(".xls") ? (
                          <FaFileExcel className="w-5 h-5 text-green-600" />
                        ) : (
                          <FaFile className="w-5 h-5 text-gray-500" />
                        )
                      ) : (
                        <FaFile className="w-5 h-5 text-gray-500" />
                      )}
                      <div className="min-w-0 flex-1">
                        <h3 className="font-semibold text-gray-800 line-clamp-1 text-sm sm:text-base">
                          {doc.DocumentName}
                        </h3>
                        <p className="text-xs sm:text-sm text-gray-500 line-clamp-1">
                          {doc.DocumentNo}
                        </p>
                      </div>
                    </div>
                    <span
                      className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        doc.StatusId === 2
                          ? "bg-green-100 text-green-800"
                          : doc.StatusId === 1
                          ? "bg-yellow-100 text-yellow-800"
                          : doc.StatusId === 3
                          ? "bg-red-100 text-red-800"
                          : doc.StatusId === 4
                          ? "bg-red-100 text-red-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {doc.StatusId === 2
                        ? "Approved"
                        : doc.StatusId === 1
                        ? "Pending"
                        : doc.StatusId === 3
                        ? "Rejected"
                        : doc.StatusId === 4
                        ? "Cancelled"
                        : "Unknown"}
                    </span>
                  </div>

                  <div className="space-y-2 mb-4">
                    <div className="flex justify-between text-xs sm:text-sm">
                      <span className="text-gray-500">Project Type</span>
                      <span className="text-gray-700 font-medium">
                        {doc.ProjectTypeName}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs sm:text-sm">
                      <span className="text-gray-500">Customer</span>
                      <span className="text-gray-700 font-medium">
                        {doc.CustomerName}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs sm:text-sm">
                      <span className="text-gray-500">Upload Date</span>
                      <span className="text-gray-700">
                        {new Date(doc.UploadDate).toLocaleDateString()}
                      </span>
                    </div>
                  </div>

                  <div className="flex justify-end items-center space-x-1 sm:space-x-2 pt-4 border-t border-gray-100">
                    <button
                      onClick={() => handleNavigation(doc.DocumentID)}
                      className="p-1.5 sm:p-2 text-[#8B4513] hover:bg-[#8B4513]/10 rounded-lg transition-colors duration-300"
                      title="View"
                    >
                      <FaEye className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                    </button>
                    <button
                      onClick={() => handleEdit(doc.DocumentID)}
                      className="p-1.5 sm:p-2 text-[#8B4513] hover:bg-[#8B4513]/10 rounded-lg transition-colors duration-300"
                      title="Edit"
                    >
                      <FaEdit className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                    </button>
                    <button
                      className="p-1.5 sm:p-2 text-[#8B4513] hover:bg-[#8B4513]/10 rounded-lg transition-colors duration-300"
                      title="Download"
                    >
                      <FaDownload className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                    </button>
                    <button
                      className="p-1.5 sm:p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors duration-300"
                      title="Delete"
                    >
                      <FaTrash className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="mt-6 sm:mt-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-white px-4 py-3 rounded-lg shadow-sm">
              <div className="text-sm text-gray-700 text-center md:text-left">
                <p className="md:hidden">
                  Page {currentPage} of {totalPages}
                </p>
                <p className="hidden md:block">
                  Showing <span className="font-medium">{startIndex + 1}</span>{" "}
                  to{" "}
                  <span className="font-medium">
                    {Math.min(endIndex, totalItems)}
                  </span>{" "}
                  of <span className="font-medium">{totalItems}</span> results
                </p>
              </div>

              {/* Mobile and Tablet Pagination */}
              <div className="flex justify-between md:hidden w-full">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${
                    currentPage === 1
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                  }`}
                >
                  <ChevronLeftIcon className="h-4 w-4 mr-1" />
                  Previous
                </button>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-700">
                    {currentPage} / {totalPages}
                  </span>
                </div>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`flex items-center px-3 py-1.5 text-sm font-medium rounded-md ${
                    currentPage === totalPages
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                  }`}
                >
                  Next
                  <ChevronRightIcon className="h-4 w-4 ml-1" />
                </button>
              </div>

              {/* Desktop Pagination */}
              <div className="hidden md:flex md:flex-1 md:items-center md:justify-end">
                <nav
                  className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                  aria-label="Pagination"
                >
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${
                      currentPage === 1
                        ? "cursor-not-allowed"
                        : "hover:text-gray-700"
                    }`}
                  >
                    <span className="sr-only">Previous</span>
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  {renderPaginationButtons()}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${
                      currentPage === totalPages
                        ? "cursor-not-allowed"
                        : "hover:text-gray-700"
                    }`}
                  >
                    <span className="sr-only">Next</span>
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </>
      )}
      {loading && <LoadingAnimation />}
    </div>
  );
};

export default AddProject;
